import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../css/OurDiary.css";
import AdminNavbar from "./AdminNavbar";
const OurDiary = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [author, setAuthor] = useState("");
  const [password, setPassword] = useState("");
  const [content, setContent] = useState("");
  const [diaries, setDiaries] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [draftContent, setDraftContent] = useState("");
  const [originalContent, setOriginalContent] = useState("");
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchField, setSearchField] = useState("title"); // default search field

  const navigate = useNavigate(); // Add this for navigation
  const directry = "https://snapcourse.in/secretme/aurandar/ayushi/directry/"
  // const imageUrl = "ChatGPT Image May 15, 2025, 02_30_30 PM.png";
  const imageUrl = [
    "ChatGPT Image May 15, 2025, 02_30_30 PM.png",
    "Screenshot_From_2025-05-04_09-54-48-removebg-preview-removebg-preview (4).jpg",
    "ChatGPT Image May 15, 2025, 02_30_30 PM (2).png",
    "3235.avif",
    "istockphoto-473012660-612x612.jpg",
    "photo_2025-06-04_09-08-25.jpg",
    "photo_2025-06-04_09-08-26.jpg",
    "photo_2025-06-04_09-08-29.jpg",
    "photo_2025-06-04_13-36-47.jpg",
    "photo_2025-06-04_13-36-46.jpg",
    "photo_2025-06-04_13-36-43.jpg",
  ]
  const [currentImage, setCurrentImage] = useState(imageUrl[Math.floor(Math.random() * imageUrl.length)]);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomImage = imageUrl[Math.floor(Math.random() * imageUrl.length)];
      setCurrentImage(randomImage);
    }, 3000);
    return () => clearInterval(interval);
  }, [imageUrl]);
  const frogimageUrl = "istockphoto-1385404682-612x612.jpg";

  // Modal state for content writing
  const [isContentModalOpen, setIsContentModalOpen] = useState(false);
  const [selectedDiaryId, setSelectedDiaryId] = useState(null);
  useEffect(() => {
    // Dynamically load Bootstrap CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    link.integrity =
      "sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH";
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);

    // Dynamically load Bootstrap JS
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js";
    script.integrity =
      "sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz";
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    // Cleanup to remove Bootstrap when component unmounts
    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const disableShortcuts = (e) => {
      if (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) {
        e.preventDefault();
        alert("All keyboard shortcuts are disabled on this page.");
      }
    };

    const disableRightClick = (e) => {
      e.preventDefault();
      alert("Right-click is disabled on this page.");
    };

    window.addEventListener("keydown", disableShortcuts);
    window.addEventListener("contextmenu", disableRightClick);

    return () => {
      window.removeEventListener("keydown", disableShortcuts);
      window.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  useEffect(() => {
    const screenProtection = document.createElement("div");
    screenProtection.className = "screenshot-protection";
    document.body.appendChild(screenProtection);

    // Hide content when PrintScreen is pressed
    window.addEventListener("keydown", (e) => {
      if (e.key === "PrintScreen") {
        screenProtection.style.display = "block";
        setTimeout(() => (screenProtection.style.display = "none"), 1000);
      }
    });

    // Hide content if tab is switched (common in screen recording tools)
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        screenProtection.style.display = "block";
      } else {
        screenProtection.style.display = "none";
      }
    });
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", (e) => {
      if (e.key === "PrintScreen") {
        alert("Screenshots are not allowed on this page.");
        document.querySelector("body").style.opacity = "0"; // Makes content vanish during the attempt
        setTimeout(() => {
          document.querySelector("body").style.opacity = "1";
        }, 1000); // Delay to restore content
      }
    });
  }, []);

  // Fetch all diaries
  useEffect(() => {
    axios
      .get("https://snapcourse.in/fun/get_diaries.php")
      .then((response) => setDiaries(response.data))
      .catch((error) => console.error("Error fetching diaries:", error));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("author", author);
    formData.append("password", password);

    try {
      const response = await axios.post(
        "https://snapcourse.in/fun/submit_diary.php",
        formData
      );
      alert(response.data);
      window.location.reload();
    } catch (error) {
      alert("Error submitting diary entry.");
    }

    setTitle("");
    setDescription("");
    setAuthor("");
    setPassword("");
  };
  // Auto-save draft to localStorage
  useEffect(() => {
    const saveDraft = () => {
      if (content) {
        localStorage.setItem(`draft_${selectedDiaryId}`, content);
      }
    };

    const interval = setInterval(saveDraft, 5000); // Auto-save every 5 seconds

    return () => clearInterval(interval); // Clean up interval on unmount
  }, [content, selectedDiaryId]);

  // Load saved draft when content modal opens
  useEffect(() => {
    const savedDraft = localStorage.getItem(`draft_${selectedDiaryId}`);
    if (savedDraft) {
      setDraftContent(savedDraft);
      setShowDraftModal(true); // Show custom modal instead of `confirm()`
    }
  }, [selectedDiaryId]);

  // Custom Draft Modal for Restoring Content
  {
    showDraftModal && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Unsaved Draft Found</h3>
          <p>You have an unsaved draft. Would you like to load it?</p>
          <div className="modal-actions">
            <button
              onClick={() => {
                setContent(draftContent);
                setShowDraftModal(false); // Load the draft and close modal
              }}
            >
              Load Draft
            </button>
            <button
              onClick={() => {
                setShowDraftModal(false);
                setContent(""); // Ignore draft and start fresh
              }}
            >
              Ignore Draft
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Verify password before showing content modal

  const handleAddContentClick = async (id) => {
    showAlert("Enter password to access content:", async (enteredPassword) => {
      if (!enteredPassword) return;

      const formData = new FormData();
      formData.append("id", id);
      formData.append("password", enteredPassword);

      try {
        const response = await axios.post(
          "https://snapcourse.in/fun/verify_password.php",
          formData
        );

        if (response.data.success) {
          // Store the ID and password in state
          setSelectedDiaryId(id);
          setPassword(enteredPassword);

          const contentData = new FormData();
          contentData.append("id", id);

          const contentResponse = await axios.post(
            "https://snapcourse.in/fun/get_diary_content.php",
            contentData
          );

          const savedDraft = localStorage.getItem(`draft_${id}`);
          if (savedDraft) {
            setContent(savedDraft); // Automatically load the saved draft
          } else {
            setContent(contentResponse.data.content || "");
          }

          // Redirect to the new TextEditor route and pass state
          navigate('/admin/texteditor', {
            state: { diaryId: id, password: enteredPassword }
          });
        } else {
          showAlert("Invalid password. Access denied.");
        }
      } catch (error) {
        showAlert("Error verifying password.");
      }
    });
  };


  const handleAddContentSubmit = async () => {
    const formData = new FormData();
    formData.append("id", selectedDiaryId);
    formData.append("content", content);
    formData.append("password", password);

    try {
      const response = await axios.post(
        "https://snapcourse.in/fun/add_content.php",
        formData
      );
      alert(response.data);

      // Clear draft after successful submission
      localStorage.removeItem(`draft_${selectedDiaryId}`);

      setIsContentModalOpen(false);
      window.location.reload();
    } catch (error) {
      alert("Error adding content.");
    }
  };

  const handleDelete = async (id) => {
    showAlert("Enter password to delete entry:", async (enteredPassword) => {
      if (!enteredPassword) return;

      const formData = new FormData();
      formData.append("id", id);
      formData.append("password", enteredPassword);

      try {
        const response = await axios.post(
          "https://snapcourse.in/fun/verify_password.php",
          formData
        );

        if (response.data.success) {
          await axios.post(
            "https://snapcourse.in/fun/delete_diary.php",
            formData
          );
          showAlert("Diary entry deleted!");
          setDiaries(diaries.filter((diary) => diary.id !== id));
        } else {
          showAlert("Invalid password. Deletion denied.");
        }
      } catch (error) {
        showAlert("Error deleting entry.");
      }
    });
  };

  const handlePreview = async (id) => {
    showAlert(
      "Enter password to preview the entry:",
      async (enteredPassword) => {
        if (!enteredPassword) return;

        const verifyFormData = new FormData();
        verifyFormData.append("id", id);
        verifyFormData.append("password", enteredPassword);

        try {
          const verifyResponse = await axios.post(
            "https://snapcourse.in/fun/verify_password.php",
            verifyFormData
          );

          if (verifyResponse.data.success) {
            const formData = new FormData();
            formData.append("id", id);

            const response = await axios.post(
              "https://snapcourse.in/fun/preview_diary.php",
              formData
            );

            if (response.data.success) {
              const diary = response.data.data;
              const diaryContent = diary.content || "No content available";

              // Store the original content before hiding it
              setOriginalContent(document.querySelector("body").innerHTML);

              // Create a preview container
              const previewContainer = document.createElement("div");
              previewContainer.className = "preview-container";
              previewContainer.innerHTML = `
            <div class="preview-content">
            <h2>${diary.title}</h2>
              <p><strong>Description:</strong> ${diary.description}</p>
              <p><strong>Author:</strong> ${diary.author}</p>
              <div>${diaryContent}</div>
              <button id="cancelPreview" class="cancel-btn">Cancel Preview</button>
            </div>
          `;

              document.body.innerHTML = "";
              document.body.appendChild(previewContainer);

              // Cancel Preview Functionality
              document
                .getElementById("cancelPreview")
                .addEventListener("click", () => {
                  document.body.innerHTML = originalContent;
                });
            } else {
              showAlert(response.data.error || "Error fetching diary content.");
            }
          } else {
            showAlert("Invalid password or access denied.");
          }
        } catch (error) {
          console.error("Error accessing diary:", error);
          showAlert("Error accessing diary. Please try again.");
        }
      }
    );
  };

  // URL Access Prevention Logic
  window.addEventListener("load", () => {
    const currentId = new URLSearchParams(window.location.search).get("id");
    if (currentId && !sessionStorage.getItem(`preview_${currentId}`)) {
      alert("Access denied. Please enter the password again.");
      window.location.href = "/error-page";
    }
  });

  const handleDownloadPDF = async (diary) => {
    showAlert(
      "Enter password to download the PDF:",
      async (enteredPassword) => {
        if (!enteredPassword) {
          showAlert("Password is required to download the PDF.");
          return;
        }

        const verifyFormData = new FormData();
        verifyFormData.append("id", diary.id);
        verifyFormData.append("password", enteredPassword);

        try {
          const verifyResponse = await axios.post(
            "https://snapcourse.in/fun/verify_password.php",
            verifyFormData
          );

          if (!verifyResponse.data.success) {
            showAlert("Invalid password. Download denied.");
            return;
          }

          const formData = new FormData();
          formData.append("id", diary.id);

          const contentResponse = await axios.post(
            "https://snapcourse.in/fun/get_my_content.php",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          const diaryContent =
            contentResponse.data.content || "No content available";

          const doc = new jsPDF();

          const contentElement = document.createElement("div");
          contentElement.innerHTML = `
              <h2>${diary.title}</h2>
              <p><strong>Description:</strong> ${diary.description}</p>
              <p><strong>Author:</strong> ${diary.author}</p>
              <div>${diaryContent}</div>
          `;

          document.body.appendChild(contentElement);

          await html2canvas(contentElement, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            doc.addImage(imgData, "PNG", 10, 10, 180, 0);
            doc.save(`${diary.title}.pdf`);
          });

          document.body.removeChild(contentElement);
        } catch (error) {
          console.error("Error fetching content:", error);
          showAlert("Error fetching content. Please try again.");
        }
      }
    );
  };

  // Utility function to create a Bootstrap-styled alert
  let alertContainer = null; // Track existing alert to prevent multiple pop-ups

  function showAlert(message, callback = () => { }) {
    if (alertContainer) return; // Prevent multiple alerts from stacking

    // Create overlay to blur background
    const overlay = document.createElement("div");
    overlay.className = "alert-overlay";
    overlay.style.cssText = `
        position: fixed;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background: rgba(0, 0, 0, 0.6); 
        z-index: 9998; 
    `;

    // Create alert container
    alertContainer = document.createElement("div");
    alertContainer.className = "alert-container";
    alertContainer.style.cssText = `
        position: fixed;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        background: #fff;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        width: 350px;
    `;

    alertContainer.innerHTML = `
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
            <strong>Alert:</strong> ${message}
            <div class="d-flex align-items-center mt-2">
                <input type="password" id="alertPasswordInput" class="form-control me-2" placeholder="Enter Password" />
                <button class="btn btn-primary" id="alertConfirmBtn">Confirm</button>
            </div>
            <button type="button" class="btn-close" id="alertCancelBtn" aria-label="Close"></button>
        </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(alertContainer);

    // Handle confirmation
    document.getElementById("alertConfirmBtn").addEventListener("click", () => {
      const enteredPassword =
        document.getElementById("alertPasswordInput").value;
      if (enteredPassword) {
        callback(enteredPassword); // Pass the password back to the original function
      } else {
        alert("Password is required.");
      }

      closeAlert(); // Close the alert after confirmation
    });

    // Handle cancellation (Close button)
    document
      .getElementById("alertCancelBtn")
      .addEventListener("click", closeAlert);

    // Close Alert Function
    function closeAlert() {
      if (alertContainer) {
        alertContainer.remove();
        alertContainer = null;
      }

      if (overlay) {
        overlay.remove();
      }
    }
  }
const handleSearch = () => {
  axios
    .get("https://snapcourse.in/fun/get_diaries.php")
    .then((response) => {
      const allDiaries = response.data;
      const filtered = allDiaries.filter((diary) => {
        const fieldValue = diary[searchField]?.toLowerCase() || "";
        return fieldValue.includes(searchQuery.toLowerCase());
      });
      setDiaries(filtered);
    })
    .catch((error) => console.error("Error fetching diaries:", error));
};

  return (
    <>
      <AdminNavbar />

      <div>
        <h2>Sakhi Diary L.T.D</h2>
        <form className="diary-form" onSubmit={handleSubmit}>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Title"
            required
          />
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Description"
            required
          />
          <input
            type="text"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            placeholder="Author"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Set Password"
          />
          <button type="submit">Add Diary</button>
        </form>

        <h2>All Diaries</h2>
        <h2>"Apne Smile Ko Lock Kar Lo Ise Freeze Kar Lo 😁"</h2>
        <div className="search-bar p-2 bg-light d-flex align-items-center gap-2">
          <select
            className="form-select w-auto"
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
          >
            <option value="title">Title</option>
            <option value="author">Author</option>
            <option value="description">Description</option>
            <option value="date">Date</option>
          </select>

          <input
            type="text"
            className="form-control"
            placeholder={`Search by ${searchField}`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <button className="btn btn-primary" onClick={handleSearch}>
            Search
          </button>
        </div>

        <ul>
          {diaries.map((diary) => (
            <li key={diary.id}>

              <h3>{diary.title}
                {/* <img src={directry + currentImage} alt="no image" width="87px" className="rounded-lg shadow-lg" /><img src={directry + frogimageUrl} alt="frog image" width="87px" /> */}
                {/* <video className="rounded-lg shadow-lg" src={directry + "video.mp4"} alt="chill" muted autoPlay loop height="100px"></video> */}</h3>
              <p>{diary.description}</p>
              <p>
                <strong>Author:</strong> {diary.author}
              </p>
              <button onClick={() => handlePreview(diary.id)}>Preview</button>
              <button onClick={() => handleAddContentClick(diary.id)}>
                Add Content
              </button>
              <button onClick={() => handleDownloadPDF(diary)}>
                Download PDF
              </button>
              <button onClick={() => handleDelete(diary.id)}>Delete</button>
            </li>
          ))}
        </ul>

        {/* Modal for Content Writing */}
        {isContentModalOpen && (
          <div className="custom-modal">
            <div className="modal-content">
              <h2>Add/Edit Content</h2>
              <ReactQuill
                value={content}
                onChange={setContent}
                placeholder="Start writing your blog content here..."
              />
              <button onClick={handleAddContentSubmit}>Save Content</button>
              <button onClick={() => setIsContentModalOpen(false)}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OurDiary;
